import { useState } from "react";
import { Outlet, useParams } from "react-router-dom";

import AdminClientLayoutWrapper from "@/components/layout/client/AdminClientLayoutWrapper";
import { ClientRealtimeSubscriber } from "@/features/realtime";
import { ClientProvider } from "@/lib/contexts/Client/ClientProvider";
import { useAuth } from "@/lib/hooks/useAuth";
import { CLIENT_REALTIME_FEATURES } from "@/routes/client-realtime";
import { ClientTenantGuard } from "@/routes/ClientTenantGuard";
import { BreadcrumbType } from "@/types/breadcrumb-types";

export interface ClientOutletContext {
  setBreadcrumb: (breadcrumb?: BreadcrumbType) => void;
  setTitle: (title?: string) => void;
  setExcludeInnerLayout: (exclude: boolean) => void;
}

export const ClientRoute = () => {
  const { clientId } = useParams();
  const { tenantId } = useAuth();

  const [breadcrumb, setBreadcrumb] = useState<BreadcrumbType | undefined>();
  const [title, setTitle] = useState<string | undefined>();
  const [excludeInnerLayout, setExcludeInnerLayout] = useState<boolean>(false);
  // Context object to pass to child routes
  const outletContext: ClientOutletContext = {
    setBreadcrumb,
    setTitle,
    setExcludeInnerLayout,
  };

  return (
    <ClientProvider clientId={clientId} tenantId={tenantId}>
      <ClientRealtimeSubscriber clientId={clientId} features={CLIENT_REALTIME_FEATURES} />
      <ClientTenantGuard>
        <AdminClientLayoutWrapper
          clientId={clientId!} // Non-null assertion since we know clientId exists in this route
          breadcrumb={breadcrumb}
          title={title}
          excludeInnerLayout={excludeInnerLayout}
        >
          <Outlet context={outletContext} />
        </AdminClientLayoutWrapper>
      </ClientTenantGuard>
    </ClientProvider>
  );
};
